import React from 'react';
import { CTAButton } from './CTAButton';
import { SectionWrapper } from './SectionWrapper';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <SectionWrapper bgColor="cream" className="pt-20 md:pt-32" data-id="element-75">
      <div className="text-center mb-10" data-id="element-76">
        <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-brand-forest leading-tight mb-6" data-id="element-77">
          El Manual De Digestión Ligera: Vuelve A Comer Sin Miedo Al Reflujo
        </h1>
        <h2 className="text-xl md:text-2xl text-gray-700 leading-relaxed max-w-3xl mx-auto" data-id="element-78">
          La guía paso a paso para eliminar la acidez nocturna y la inflamación
          post-comida en 7 días, diseñada específicamente para el cuerpo (y el
          sazón) latino después de los 50.
        </h2>
      </div>

      <div className="flex flex-col items-center justify-center mb-12" data-id="element-79">
        <motion.div initial={{
        rotate: -2,
        y: 20,
        opacity: 0
      }} animate={{
        rotate: 0,
        y: 0,
        opacity: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative w-full max-w-md mx-auto mb-10" data-id="element-80">
          <div className="absolute inset-0 bg-brand-amber opacity-20 blur-2xl rounded-full transform scale-90" data-id="element-81"></div>
          <img src="https://cdn.magicpatterns.com/uploads/mVg4ETyRSdbj6a7BuFtPaM/Portada_Manual-Digestion-Ligera.png" alt="Portada del Manual de Digestión Ligera" className="relative z-10 w-full h-auto rounded-lg shadow-2xl transform hover:scale-[1.02] transition-transform duration-500" data-id="element-82" />
        </motion.div>

        <CTAButton href="#oferta" data-id="element-83" />
      </div>
    </SectionWrapper>;
}